
// This is the value of tINVALID in the C++ code of the SC400
// tINVALID == 0x80000000 on 32b SC400
export enum eINVALID {
  eINVALID = -2147483648
}
